var _defs, _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgLogoSetting1 = function SvgLogoSetting1(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32.67,
    height: 32.67,
    viewBox: "0 0 49 49",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "g1fla",
    d: "M879.955 539.885l-8.43-8.44 18.107-18.29 8.585 8.583z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "g1flb",
    d: "M880.016 503.541l-8.583-8.585-18.198 18.199a6.065 6.065 0 0 0-.004 8.578l.004.004 18.198 18.199 8.42-8.458-13.753-14.02z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "g1flc",
    d: "M898.214 513.155l-18.199-18.199a6.07 6.07 0 0 0-8.584 0 6.066 6.066 0 0 0 0 8.582l18.208 18.2a6.07 6.07 0 0 0 8.583-8.583z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "g1fld",
    d: "M875.658 529.7a6.015 6.015 0 1 1 0 12.03 6.015 6.015 0 0 1 0-12.03z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-851 -493)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#8ab4f8",
    xlinkHref: "#g1fla"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-851 -493)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#4285f4",
    xlinkHref: "#g1flb"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-851 -493)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#8ab4f8",
    xlinkHref: "#g1flc"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-851 -493)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#246fdb",
    xlinkHref: "#g1fld"
  })))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLogoSetting1, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/logo_setting_1.c1b24be6.svg";
export { ForwardRef as ReactComponent };